import * as React from 'react';
import {createFileRoute} from '@tanstack/react-router';
import { Link } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  return(
    <div className="flex flex-col">
      <div className="homepage-hero-container flex items-end">
        <div className="homepage-hero-text px-4">
          <h1>
            The custom bike
            experts
          </h1>
        </div>
      </div>
      <div className="p-8 bg-gray-200">
        <Link to="/systems/group/680d64584cd61a708f6cb964">
          <img src="/public/tavelo_logo_v4.webp" alt="Tavelo Logo" />
        </Link>
      </div>
      <div className="p-8 bg-gray-400">
        <Link to="/systems/group/680d55c34cd61a708f6cb963">
          <img src="/public/seka_logo.webp" alt="SEKA Logo" />
        </Link>
      </div>
    </div>
  )
}
